import { Button, Dropdown, Menu, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getConsultantProjects } from "../../Redux/Actions/consultantAction";
import CurrentSubscription from "./CurrentSubscription";

const ViewConsultantTable = ({ id, data }) => {
  const dispatch = useDispatch();

  const [selectedTable, setSelectedTable] = useState("projects");

  const handleTableSelection = (table) => {
    setSelectedTable(table);
  };

  const navigate = useNavigate();
  const handleView = (record) => {
    navigate(`/manage_projects/view/${record.key}`, {
      state: { from: "consultant_view", consultant_id: id },
    });
  };
  const { loading, projectData, error } = useSelector(
    (state) => state.consultantProjects
  );
  useEffect(() => {
    dispatch(getConsultantProjects({
      consultant_id: id
    }))
  }, [id])
  const columnsProjects = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Project Name",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => (
        <span style={{ color: status === "active" ? "green" : "red" }}>
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (date) => (date ? new Date(date).toLocaleString() : "N/A"),
    },
    {
      title: "Action",
      align: "center",
      key: "action",
      render: (_, record) => {
        const menu = (
          <Menu>
            <Menu.Item key="view" onClick={() => handleView(record)}>
              View
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu} trigger={['click']}>
            <Button icon={<EllipsisOutlined />} />
          </Dropdown>
        );
      },
    },
  ];

  const columnsLeads = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Lead Name",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      align: "center",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      align: "center",
    },
    {
      title: "Interested In",
      dataIndex: "interest",
      key: "interest",
      align: "center",
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (date) => (date ? new Date(date).toLocaleString() : "N/A"),
    },
  ];

  const columnsSubscription = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Plan Name",
      dataIndex: "plan_name",
      key: "plan_name",
      align: "center",
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      align: "center",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      align: "center",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      render: (amt) => `₹ ${amt}`,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => (
        <span style={{ color: status === "active" ? "green" : "red" }}>
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
      ),
    },
  ];
  const columnsRequestChangeProjects = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Plan Name",
      dataIndex: "plan_name",
      key: "plan_name",
      align: "center",
    },
  ]
  const leads = [
    {
      name: "Rahul Verma",
      email: "rahul@example.com",
      phone: "9876543210",
      interest: "2BHK Apartment",
      created_at: "2024-11-01T09:15:00Z",
    },
    {
      name: "Priya Sharma",
      email: "priya@example.com",
      phone: "9123456789",
      interest: "Studio Apartment",
      created_at: "2024-11-03T11:00:00Z",
    },
  ];

  const subscriptions = [
    {
      plan_name: "Premium Plan",
      start_date: "2024-12-01",
      end_date: "2025-12-01",
      amount: 9999,
      status: "active",
    },
    {
      plan_name: "Basic Plan",
      start_date: "2023-11-01",
      end_date: "2024-11-01",
      amount: 4999,
      status: "expired",
    },
  ];
  const changeProjectData = [
    {
      plan_name: "Premium Plan",
      start_date: "2024-12-01",
      end_date: "2025-12-01",
      amount: 9999,
      status: "active",
    },
    {
      plan_name: "Basic Plan",
      start_date: "2023-11-01",
      end_date: "2024-11-01",
      amount: 4999,
      status: "expired",
    },
  ];
  const formattedProjects = projectData?.map((item) => ({
    key: item?.project?._id,
    name: item?.project?.project_name,
    location: item?.project?.street_address,
    status: item?.status,
    created_at: item?.project?.launch_date,
    full: item,
  }));
  return (
    <div>
      <div className="details_table_right margin-w-10">
        <div style={{boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom:"20px"}} className="bg-white border-10 padding-10 ">
          <div className="hover_panel">
            <h4
              className={selectedTable === "projects" ? "clicked" : ""}
              onClick={() => handleTableSelection("projects")}
            >
              Projects
            </h4>
            <h4
              className={selectedTable === "lead" ? "clicked" : ""}
              onClick={() => handleTableSelection("lead")}
            >
              Leads
            </h4>
            <h4
              className={selectedTable === "subscription" ? "clicked" : ""}
              onClick={() => handleTableSelection("subscription")}
            >
              Subscription
            </h4>
            <h4
              className={selectedTable === "changeProject" ? "clicked" : ""}
              onClick={() => handleTableSelection("changeProject")}
            >
              Change Project Request
            </h4>
          </div>
        </div>

        {selectedTable === "projects" && (
          <Table
            columns={columnsProjects}
            dataSource={formattedProjects}
            rowKey="key"
            loading={loading}
            pagination={false}
          />
        )}

        {selectedTable === "lead" && (
          <Table
            columns={columnsLeads}
            dataSource={leads}
            rowKey={(record, index) => index}
            pagination={false}
          />
        )}

        {selectedTable === "subscription" && (
          <CurrentSubscription data={data} />
        )}
        {selectedTable === "changeProject" && (
          <Table
            columns={columnsRequestChangeProjects}
            dataSource={changeProjectData}
            rowKey={(record, index) => index}
            pagination={false}
          />
        )}
      </div>
    </div>
  );
};

export default ViewConsultantTable;
